import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import dayjs from "dayjs";
import { getCommonApiParams } from "../../../../utils/redux-helpers.js";
import { API_DATE_FORMAT } from "../../../../app_constants.js";
import { api } from "../api.js";

export const SET_UPDATES_LOADING = "saga/staffGrossSales/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/staffGrossSales/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/staffGrossSales/SET_LOADING";
export const SET_DATES = "saga/staffGrossSales/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/staffGrossSales/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/staffGrossSales/FETCH_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER = "saga/staffGrossSales/FETCH_CURRENT_USER";
export const DATA_SUCCESS = "saga/staffGrossSales/DATA_SUCCESS";

export const UPDATE_CUSTOM_RANGE = "saga/staffGrossSales/UPDATE_CUSTOM_RANGE";
export const UPDATE_DATES = "saga/staffGrossSales/UPDATE_DATES";
export const UPDATE_FILTER = "saga/staffGrossSales/UPDATE_FILTER";
export const UPDATE_DATA = "saga/staffGrossSales/UPDATE_DATA";

export const RESET_SELECTED_FILTERS = "saga/staffGrossSales/RESET_SELECTED_FILTERS";
export const RESET_DATA = "saga/staffGrossSales/RESET_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDates: createAction(UPDATE_DATES),
  updateFilter: createAction(UPDATE_FILTER),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA)
};

export default function* watchStaffGrossSales() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
}

function* getCurrentUserData({ payload }) {
  try {
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload });
    yield put({ type: SET_LOADING, payload: true });

    yield setDates();
    yield fetchFilters();
    yield fetchTableData();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  try {
    const params = yield getApiParams();
    const { data } = yield call(api.getFilters, params);

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
  }
}

function* fetchTableData() {
  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const params = yield getApiParams();
    const { data } = yield call(api.getData, params);

    yield put({ type: DATA_SUCCESS, payload: data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield fetchTableData();
}

function* setDates() {
  const endDate = yield select((state) => state.staffGrossSales.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: { startDate, endDate }
  });
}

function* resetData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: RESET_SELECTED_FILTERS });
  yield setDates();

  try {
    yield fetchTableData();
  } catch (error) {
    console.error(error);
  }
}

function* getApiParams() {
  const commonParams = yield getCommonApiParams("commonReducer", "commonProps");

  const {
    requestDates: { startDate, endDate },
    selectedFilters: { staffs, exclude_with_no_sales, include_deleted }
  } = yield select((state) => state.staffGrossSales);

  const staff_uids = (staffs || []).map((s) => s.staff_uid);

  return {
    ...commonParams,
    start_date: startDate,
    end_date: endDate,
    ...(staff_uids.length > 0 && {
      staff_uids,
      exclude_with_no_sales: exclude_with_no_sales?.id,
      include_deleted: include_deleted?.id
    }),
  };
}
